export default __webpack_public_path__ + "static/media/Tick.a2d6585d.svg";